module.exports = __webpack_public_path__ + "static/media/discover-si-console.aabe6abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/Compatibility/images/discover-si-console.png
// module id = 1243
// module chunks = 0